













































































































































































































































































import { Vue } from "vue-property-decorator";
import AppLayout from "@/components/app-layout.vue";
import $inoe from "@/config";
import { utils } from "@/util";
import FiltreBox from "@/components/app-filtres/components/box.vue";
import store from "@/store";
import { mapGetters } from "vuex";
import { CLOSE_LOADING, SHOW_LOADING } from "@/store/types";
export default Vue.extend({
  components: { AppLayout, FiltreBox },
  data() {
    return {
      infoDossier: $inoe.getInfoDossier(),
      showModalDelete: false,
      notificationPermission: Notification.permission,
      arrayContent: [] as Array<any>,
    };
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch(SHOW_LOADING);
    store
      .dispatch("parametres/fetchAll")
      .then(() => {
        store.dispatch(CLOSE_LOADING);
        next();
      })
      .catch((error) => console.error(error));
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch("parametres/clearAll");
    next();
  },
  filters: {
    inverseDate: (date: string) => {
      if (!date) return "";
      let d = utils.getDateFromString(date, "YYYY-MM-DD  HH:mm:ss");
      return d.format("DD-MM-YYYY HH:mm:ss");
    },
  },
 
  methods: {
    savePointage() {
    store.dispatch("parametres/savePointage")
    .then((json) => {
      const currentTime = utils.getCurrentTimeNow().format("YYYYMMDD");
      const dossierName = this.getNomDossier;
      const userName = this.getCurrentUser.login;
      

      const backupFileName = `backup_MobiAN_${currentTime}_${dossierName}_${userName}.json`;
      const supplementRowsFileName = `backup_MobiANSUP_${currentTime}_${dossierName}_${userName}.json`;

      this.download(json['backup'], backupFileName, "text/x-json");
      this.download(json['supplementRows'], supplementRowsFileName, "text/x-json");
    })
    .catch((error) => {
      console.error("Error saving pointage:", error);
    });
},

download(content: any, fileName: string, contentType: string) {
  var a = document.createElement("a");
  var file = new Blob([content], { type: contentType });
  a.href = URL.createObjectURL(file);
  a.download = fileName;
  a.click();
},
    deleteMobi() {
      store.dispatch("parametres/deleteMobi");
    },
    openTab(params: string) {
      switch (params) {
        case "team": {
          window.open(
            "https://play.google.com/store/apps/details?id=com.teamviewer.quicksupport.market",
            "_blank"
          );
          break;
        }
        case "anyd": {
          window.open(
            "https://play.google.com/store/apps/details?id=com.anydesk.anydeskandroid",
            "_blank"
          );
          break;
        }
        default:
          break;
      }
    },
    askPermissions() {
      if ("permission" in Notification) {
        Notification.requestPermission((result) => {
          this.notificationPermission = result;
          this.testNotification();
        });
      }
    },
    testNotification() {
      if (typeof (this as any).$swreg !== "undefined")
        (this as any).$swreg.showNotification("MobiTest", {
          body: "Notification de test Mobi OK",
          tag: "InoeMobi",
          icon: "./img/icons/android-icon-96x96.png",
        });
    },
    fetchPointages() {
      store.dispatch(SHOW_LOADING);
      store
        .dispatch("parametres/fetchPointages")
        .finally(() => store.dispatch(CLOSE_LOADING));
    },
  },
  computed: {
    ...mapGetters("moncompte", ["getCurrentUser","getNomDossier","getKeyDossierMobi"]),
    ...mapGetters("parametres", [
      "getLastSynchro",
      "getMobiVersion",
      "getLocalPointagesFalse",
      "getRemotePointagesFalse",
      "getLocalSupplementsFalse",
      "getRemoteSupplementsFalse",
      "getLocalPointagesFalseOthers",
      "getRemotePointagesFalseOthers",
      "getRemotePointagesTrueOthers",
      "getLocalSupplementsFalseOthers",
      "getRemoteSupplementsFalseOthers",
      "getRemoteSupplementsTrueOthers",
    ]),
    extractId() {
    return (inputString : any) => {
      if (inputString.includes('@')) {
        const parts = inputString.split('@');
        return parts[parts.length - 1]; // Extracts the substring after the last '@'
      } else {
        return 'Invalid input'; // Handle cases where '@' symbol is not found
      }
    };
  } 

  },
});
